export const ssabOccSubscriptionsConfig = {
  backend: {
    occ: {
      endpoints: {
        subscribeProductAvailability: 'users/${userId}/subscriptions/product/${productCode}/availability?spinner=true'
      }
    }
  }
};
